<template>
    <transition name="modal-fade">
        <div 
            class="fixed top-0 bottom-0 left-0 right-0 z-50 flex items-center justify-center bg-black bg-opacity-25" 
            @keydown.esc="close()"
            tabindex="0"
        >
            <form @submit.prevent="onSubmit" enctype="multipart/form-data">
                <div class="z-50 flex flex-col overflow-x-auto bg-vida-beige">
                    <div class="relative p-4 m-4 bg-vida-beige-2">
                        <h3 class="text-2xl font-semibold">Contactgegevens</h3>
                        <p class="mb-4">Vul je contactgegevens in zodat we jou persoonlijk design kunnen versturen!</p>
                        <div
                            class="absolute top-0 right-0 z-50 mt-4 mr-4 text-sm cursor-pointer"
                            @click="close()"
                        >
                            <i class="text-lg far fa-times"></i>
                        </div>
                        <div class="">
                            <div class="mb-8">
                                <div class="flex mt-3 space-x-5">
                                    <input
                                        type="text"
                                        name=""
                                        id="first-name"
                                        placeholder="Voornaam"
                                        class="w-1/2 p-2 border"
                                        v-model.lazy="contactForm.firstName"
                                    >
                                    <input
                                        type="text"
                                        name=""
                                        id="last-name"
                                        placeholder="Achternaam"
                                        class="w-1/2 p-2 border"
                                        v-model.lazy="contactForm.lastName"
                                    >
                                </div>
                                <div class="flex mt-3 space-x-5">
                                    <input
                                        type="email"
                                        name=""
                                        id="e-mail"
                                        placeholder="E-mailadres"
                                        class="w-1/2 p-2 border"
                                        v-model.lazy="contactForm.email"
                                    >
                                    <input
                                        type="tel"
                                        name=""
                                        id="phone"
                                        placeholder="Telefoon"
                                        class="w-1/2 p-2 border"
                                        v-model.lazy="contactForm.phone"
                                    >
                                </div>
                                <div class="flex mt-3 space-x-5">
                                    <input
                                        type="text"
                                        name=""
                                        id="street"
                                        placeholder="Straat + huisnummer"
                                        class="w-1/2 p-2 border"
                                        v-model.lazy="contactForm.address"
                                    >
                                    <input
                                        type="number"
                                        name=""
                                        id="area-code"
                                        placeholder="Postcode"
                                        class="w-1/2 p-2 border"
                                        v-model.lazy="contactForm.zip"
                                    >
                                </div>
                                <div class="flex mt-3 space-x-5">
                                    <input
                                        type="text"
                                        name=""
                                        id="city"
                                        placeholder="Gemeente"
                                        class="w-1/2 p-2 border"
                                        v-model.lazy="contactForm.city"
                                    >
                                    <input
                                        type="text"
                                        name=""
                                        id="country"
                                        placeholder="Land"
                                        class="w-1/2 p-2 border"
                                        v-model.lazy="contactForm.country"
                                    >
                                </div>
                                <div class="flex mt-3 space-x-5">
                                    <select
                                        class="w-1/2 p-2 border"
                                        v-model="contactForm.vat"
                                    >
                                        <option disabled value="">Selecteer btw stelsel</option>
                                        <option id="basic" value="6">6% - Renovatie - woning &#62; 10 jaar</option>
                                        <option id="euro" value="21">21% - nieuwbouw - woning &#60; 10 jaar</option>
                                        <option id="wc" value="0">0% - btw verlegd (btw-nummer verplicht!)</option>
                                    </select>
                                    <div class="w-1/2 p-2"></div> <!-- spacer div -->
                                </div>
                            </div>
                            <div class="mb-8">
                                <h3 class="text-2xl font-semibold">Bedrijfsgegevens <span class="text-sm">(indien van toepassing)</span></h3>
                                <div class="flex mt-3 space-x-5">
                                    <input
                                        type="text"
                                        name=""
                                        id="company-name"
                                        placeholder="Bedrijfsnaam"
                                        class="w-1/2 p-2 border"
                                        v-model.lazy="contactForm.company"
                                    >
                                    <input
                                        type="text"
                                        name=""
                                        id="vat-number"
                                        placeholder="Btw-nummer"
                                        class="w-1/2 p-2 border"
                                        v-model.lazy="contactForm.vatNumber"
                                    >
                                </div>
                            </div>
                            <div class="mb-8">
                                <h3 class="text-2xl font-semibold">Opmerkingen</h3>
                                <div class="flex mt-3 space-x-5">
                                   <textarea
                                     name="remarks"
                                        id=""
                                        cols="10"
                                        rows="3"
                                        placeholder="Aanvullende informatie betreffende uw design."
                                        class="w-full p-2 border"
                                        v-model.lazy="contactForm.remarks"
                                    >
                                    </textarea>
                                </div>
                            </div>
                        </div>
                        
                        <div class="flex items-baseline space-x-2">
                            <input
                                type="checkbox"
                                name="gdpr"
                                id="gdpr"
                                class="inline-block"
                                v-model="contactForm.gdpr_check"
                                checked
                            >
                            <p class="text-xs">Ik geef toestemming om de ingestuurde data te verwerken en om een offerte op naam te ontvangen.</p>
                        </div>
                        <button
                            class="w-full p-3 mt-6 font-semibold text-white transition duration-200 ease-linear bg-black hover:bg-vida-gray"
                            @click="sendForm()"
                        >
                            <i class="mr-1 far fa-paper-plane" v-if="loading === false"></i>
                            <i class="fad fa-spinner-third fa-spin" v-if="loading === true"></i>
                            Configuratie verzenden
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </transition>
</template>

<script>
    import { mapState } from 'vuex'
    import { mapMutations } from 'vuex'

    import axios from 'axios'

    export default {
        name: 'Modal',
        components: {

        },
        data() {
            return {
                loading: false,
            }
        },
        methods: {
            ...mapMutations([
                'setContactForm',
                'setSnapShot'
            ]),
            close() {
                this.$emit('close');
            },
            snapShotBlob() {
                this.setSnapShot(true)
            },
            async sendForm() {

                this.loading = true

                const formData = new FormData()

                Object.keys(this.contactForm).forEach(key => {
                    formData.append(key, this.contactForm[key])
                });

                // formData.append('doorType', this.doorType)
                // formData.append('doorAmount', this.doorAmount)
                // formData.append('sidePanelAmount', this.sidePanelAmount)
                // formData.append('frameColor', this.frameColor)
                // formData.append('glassType', this.glassType)
                // formData.append('doorHandleType', this.doorHandleType)

                formData.append('file', this.imageUrl)

                try {
                    await axios.post('https://api.vidamirrors.be/api/upload', formData)
                    this.loading = false
                    console.log('Data uploaded & saved in database')
                    this.close()
                }
                catch(err) {
                    console.log(err)
                    this.loading = false
                }
            },
        },
        computed: {
            ...mapState([
                'contactForm',
                'snapShot',
                'imageUrl',
                'doorType',
                'doorAmount',
                'sidePanelAmount',
                'frameColor',
                'glassType',
                'doorHandleType'
            ]),
        }
    }
</script>

<style>
    .modal-fade-enter,
    .modal-fade-leave-to {
        opacity: 0;
    }

    .modal-fade-enter-active,
    .modal-fade-leave-active {
        transition: opacity .5s ease;
    }
</style>
